import { FormlyModule } from '@ngx-formly/core';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';
import { NgxUploaderModule } from 'ngx-uploader';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { SnCamerasModule } from '@lib/cameras';
import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormColorPickerModule } from '@lib/form/color-picker';
import { SnDragSlideToggleModule } from '@lib/form/drag-slide-toggle';
import { GoogleMapModule } from '@lib/geo/google/map';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnAlertModule } from '@lib/ui/alert';
import { SnAvatarModule } from '@lib/ui/avatar';
import { SnBadgeModule } from '@lib/ui/badge';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnMenuModule } from '@lib/ui/menu';
import { SnTooltipModule } from '@lib/ui/tooltip';
import { SnColorPickerFormField } from 'libs/form/color-picker/src/lib/components/form-field/color-picker.form-field';
import { FsDragBarModule } from 'libs/ui/drag-bar/src/lib/drag-bar.module';

import {
  SnMessageListComponent,
  SnMessageScrollComponent,
  SnMessageTypingComponent,
  SnMemberListComponent,
  SnUserStatusComponent,
  SnChannelStatusComponent,
  SnChannelListComponent,
  SnChannelListItemComponent,
  SnChatUserSelectComponent,
  SnChannelActionsComponent,
  SnChatDrawerComponent,
  ChannelsToShareDialogComponent,
} from './components';
import { ChatExportTimeComponent } from './components/chat-export-time/chat-export-time.component';
import { ChatMediaMessageDescriptionDialogComponent } from './components/chat-media-message-description-dialog/chat-media-message-description-dialog.component';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';
import {
  SnChannelFormDialogComponent,
  SnInviteUsersDialogComponent,
  SnEditChannelFormDialogComponent,
  ChatChannelNameDialogComponent,
  TelestrateDialogComponent,
  CanvasComponent,
} from './components/dialogs';
import { EditMemberExpirationComponent } from './components/dialogs/edit-member-expiration/edit-member-expiration.component';
import {
  SnDirectFormComponent,
  SnOrganizationFormComponent,
  SnEditOrganizationFormComponent,
} from './components/forms';
import {
  SnMessageItemComponent,
  SnMessageViewComponent,
  SnMessageEditComponent,
  SnTextMessageComponent,
  SnMessageTimestampComponent,
  SnCameraShareComponent,
  SnCameraListShareComponent,
  SnMediaMessageComponent,
} from './components/message-item';
import {
  SnChannelContainer,
  SnNewMessageContainer,
  SnChatChannelListContainer,
  SnChannelMembersDrawerContainer,
  SnChannelMembersListContainer,
} from './containers';
import { SnUserFilterPipe, SnMarkedPipe, SnSanitizeHtmlPipe } from './pipes';
import { SnChatDialogsService } from './services/chat-dialogs.service';

@NgModule({
  imports: [
    // Angular
    FormsModule,
    CommonModule,
    RouterModule,
    TextFieldModule,
    ReactiveFormsModule,
    SnCamerasModule,
    // Material
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatInputModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSelectModule,
    MatTabsModule,
    MatSliderModule,
    MatMenuModule,
    DragDropModule,
    MatButtonModule,
    MatIconModule,
    NgxLoadingButtonsModule,
    MatDialogModule,
    // Others
    NgxUploaderModule,
    // Libs
    SnFormModule,
    SnMenuModule,
    SnIconModule,
    SnListModule,
    SnBadgeModule,
    SnCommonModule,
    FsDragBarModule,
    SnAvatarModule,
    SnButtonModule,
    SnDrawerModule,
    SnTooltipModule,
    SnActionsModule,
    SnDragSlideToggleModule,
    SnDataListModule,
    GoogleMapModule,
    SnFormColorPickerModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'color-picker',
          component: SnColorPickerFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    SnAlertModule,
    TranslationModule
],
  exports: [
    SnChannelContainer,
    SnChannelActionsComponent,
    SnChatChannelListContainer,
    SnChannelMembersListContainer,
    SnChatDrawerComponent,
    SnMemberListComponent,
    ChatChannelNameDialogComponent,
    SnMediaMessageComponent,
    TelestrateDialogComponent,
    CanvasComponent,
    ChatWidgetComponent,
    ChatMediaMessageDescriptionDialogComponent,
  ],
  declarations: [
    // Channels
    SnChannelContainer,
    SnNewMessageContainer,
    SnChannelMembersListContainer,
    SnChannelStatusComponent,
    SnMemberListComponent,
    SnChannelMembersDrawerContainer,
    SnMediaMessageComponent,

    SnChatChannelListContainer,
    SnChannelListItemComponent,
    SnChannelListComponent,
    SnChannelActionsComponent,

    // Messages
    SnMessageListComponent,

    SnMessageItemComponent,
    SnMessageViewComponent,
    SnMessageEditComponent,
    SnTextMessageComponent,
    SnCameraShareComponent,
    SnCameraListShareComponent,
    SnMessageTimestampComponent,

    SnMessageScrollComponent,
    SnMessageTypingComponent,

    SnUserStatusComponent,
    SnChatUserSelectComponent,
    // Dialogs
    SnChannelFormDialogComponent,
    SnInviteUsersDialogComponent,
    SnEditChannelFormDialogComponent,
    ChannelsToShareDialogComponent,
    ChatChannelNameDialogComponent,
    // Forms
    SnDirectFormComponent,
    SnOrganizationFormComponent,
    SnEditOrganizationFormComponent,
    TelestrateDialogComponent,
    CanvasComponent,

    SnChatDrawerComponent,

    // Pipes
    SnUserFilterPipe,
    SnSanitizeHtmlPipe,
    SnMarkedPipe,
    EditMemberExpirationComponent,
    ChatExportTimeComponent,
    ChatWidgetComponent,
    ChatMediaMessageDescriptionDialogComponent,
  ],
  entryComponents: [],
  providers: [SnChatDialogsService],
})
export class SnTwilioChatModule {}
